// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p4-6";
export var imgContainer = "_p4-3";
export var menuIcon = "_p4-5";
export var pillWrapper = "_p4-2";
export var pillsContainer = "_p4-1";
export var subscriptionCard = "_p4-0";
export var subscriptionLogo = "_p4-4";